/* tslint:disable */
/* eslint-disable */
/**
 * FileManagement API
 * This is an OpenAPI for the FileManagement Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { DeleteFileResponse } from '../models';
import { DeleteOldTempFilesResponse } from '../models';
import { DownloadFileResponse } from '../models';
import { GetFileCategoryResponse } from '../models';
import { GetImageFileResponse } from '../models';
import { MoveFileResponse } from '../models';
import { MoveFilesResponse } from '../models';
import { MoveMultipleTempFilesToPermanentRequest } from '../models';
import { UploadFileResponse } from '../models';
/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a file from the permanent or temporary database.
         * @summary Deletes a file from the permanent or temporary database.
         * @param {string} UUID The url of the file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (UUID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UUID' is not null or undefined
            if (UUID === null || UUID === undefined) {
                throw new RequiredError('UUID','Required parameter UUID was null or undefined when calling deleteFile.');
            }
            const localVarPath = `/File`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            if (UUID !== undefined) {
                localVarQueryParameter['UUID'] = UUID;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes old temporary files from the database. Goes through all temporary folders and removes the ones with a timestamp older than 3 days ago.
         * @summary Deletes old temporary files from the database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOldTempFiles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Temps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads a file from the database, works on both temporary and permanent files. Works with all types of files.
         * @summary Downloads a file from the database, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (UUID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UUID' is not null or undefined
            if (UUID === null || UUID === undefined) {
                throw new RequiredError('UUID','Required parameter UUID was null or undefined when calling downloadFile.');
            }
            const localVarPath = `/Download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }


            if (UUID !== undefined) {
                localVarQueryParameter['UUID'] = UUID;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a file from the database to view, works on both temporary and permanent files. Designed for Images and PDFs.
         * @summary Gets a file from the database to view, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {string} token The access token of the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (UUID: string, token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UUID' is not null or undefined
            if (UUID === null || UUID === undefined) {
                throw new RequiredError('UUID','Required parameter UUID was null or undefined when calling getFile.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling getFile.');
            }
            const localVarPath = `/File`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (UUID !== undefined) {
                localVarQueryParameter['UUID'] = UUID;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a category of a file from the database, works on both temporary and permanent files. Designed for Images and PDFs.
         * @summary Gets a category of a file from the database, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {string} token The access token of the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileCategory: async (UUID: string, token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UUID' is not null or undefined
            if (UUID === null || UUID === undefined) {
                throw new RequiredError('UUID','Required parameter UUID was null or undefined when calling getFileCategory.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling getFileCategory.');
            }
            const localVarPath = `/FileCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (UUID !== undefined) {
                localVarQueryParameter['UUID'] = UUID;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Moves one file into the permanent database locally or online.
         * @summary Moves one file into the permanent database.
         * @param {string} UUID The url of the file to move from the temp folders.
         * @param {string} Owner The ID of the User that owns the file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFromTempToPermanent: async (UUID: string, Owner: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UUID' is not null or undefined
            if (UUID === null || UUID === undefined) {
                throw new RequiredError('UUID','Required parameter UUID was null or undefined when calling moveFromTempToPermanent.');
            }
            // verify required parameter 'Owner' is not null or undefined
            if (Owner === null || Owner === undefined) {
                throw new RequiredError('Owner','Required parameter Owner was null or undefined when calling moveFromTempToPermanent.');
            }
            const localVarPath = `/File`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }


            if (UUID !== undefined) {
                localVarQueryParameter['UUID'] = UUID;
            }

            if (Owner !== undefined) {
                localVarQueryParameter['Owner'] = Owner;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Moves multiple files into the permanent database. Each file can have different owners.
         * @summary Moves multiple files into the permanent database.
         * @param {MoveMultipleTempFilesToPermanentRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveMultipleTempFilesToPermanent: async (body?: MoveMultipleTempFilesToPermanentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload file into the temporary database locally or online.
         * @summary Upload file into the temporary database.
         * @param {string} [Type] 
         * @param {Blob} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileForm: async (Type?: string, File?: Blob, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/File`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }



            if (Type !== undefined) { 
                localVarFormParams.append('Type', Type as any);
            }

            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload file into the temporary database locally or online.
         * @summary Upload file into the temporary database.
         * @param {string} [Type] 
         * @param {string} [Category] 
         * @param {Blob} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileWithCategoryForm: async (Type?: string, Category?: string, File?: Blob, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/FileWithCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }



            if (Type !== undefined) { 
                localVarFormParams.append('Type', Type as any);
            }

            if (Category !== undefined) { 
                localVarFormParams.append('Category', Category as any);
            }

            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes a file from the permanent or temporary database.
         * @summary Deletes a file from the permanent or temporary database.
         * @param {string} UUID The url of the file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(UUID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DeleteFileResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).deleteFile(UUID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes old temporary files from the database. Goes through all temporary folders and removes the ones with a timestamp older than 3 days ago.
         * @summary Deletes old temporary files from the database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOldTempFiles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DeleteOldTempFilesResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).deleteOldTempFiles(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Downloads a file from the database, works on both temporary and permanent files. Works with all types of files.
         * @summary Downloads a file from the database, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(UUID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DownloadFileResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).downloadFile(UUID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets a file from the database to view, works on both temporary and permanent files. Designed for Images and PDFs.
         * @summary Gets a file from the database to view, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {string} token The access token of the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(UUID: string, token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetImageFileResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).getFile(UUID, token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets a category of a file from the database, works on both temporary and permanent files. Designed for Images and PDFs.
         * @summary Gets a category of a file from the database, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {string} token The access token of the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileCategory(UUID: string, token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetFileCategoryResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).getFileCategory(UUID, token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Moves one file into the permanent database locally or online.
         * @summary Moves one file into the permanent database.
         * @param {string} UUID The url of the file to move from the temp folders.
         * @param {string} Owner The ID of the User that owns the file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveFromTempToPermanent(UUID: string, Owner: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<MoveFileResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).moveFromTempToPermanent(UUID, Owner, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Moves multiple files into the permanent database. Each file can have different owners.
         * @summary Moves multiple files into the permanent database.
         * @param {MoveMultipleTempFilesToPermanentRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveMultipleTempFilesToPermanent(body?: MoveMultipleTempFilesToPermanentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<MoveFilesResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).moveMultipleTempFilesToPermanent(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Upload file into the temporary database locally or online.
         * @summary Upload file into the temporary database.
         * @param {string} [Type] 
         * @param {Blob} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileForm(Type?: string, File?: Blob, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<UploadFileResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).uploadFileForm(Type, File, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Upload file into the temporary database locally or online.
         * @summary Upload file into the temporary database.
         * @param {string} [Type] 
         * @param {string} [Category] 
         * @param {Blob} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileWithCategoryForm(Type?: string, Category?: string, File?: Blob, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<UploadFileResponse>>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).uploadFileWithCategoryForm(Type, Category, File, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes a file from the permanent or temporary database.
         * @summary Deletes a file from the permanent or temporary database.
         * @param {string} UUID The url of the file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(UUID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<DeleteFileResponse>> {
            return FileApiFp(configuration).deleteFile(UUID, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes old temporary files from the database. Goes through all temporary folders and removes the ones with a timestamp older than 3 days ago.
         * @summary Deletes old temporary files from the database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOldTempFiles(options?: AxiosRequestConfig): Promise<AxiosResponse<DeleteOldTempFilesResponse>> {
            return FileApiFp(configuration).deleteOldTempFiles(options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads a file from the database, works on both temporary and permanent files. Works with all types of files.
         * @summary Downloads a file from the database, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(UUID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<DownloadFileResponse>> {
            return FileApiFp(configuration).downloadFile(UUID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a file from the database to view, works on both temporary and permanent files. Designed for Images and PDFs.
         * @summary Gets a file from the database to view, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {string} token The access token of the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(UUID: string, token: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetImageFileResponse>> {
            return FileApiFp(configuration).getFile(UUID, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a category of a file from the database, works on both temporary and permanent files. Designed for Images and PDFs.
         * @summary Gets a category of a file from the database, works on both temporary and permanent files.
         * @param {string} UUID The url of the file to get
         * @param {string} token The access token of the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileCategory(UUID: string, token: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetFileCategoryResponse>> {
            return FileApiFp(configuration).getFileCategory(UUID, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Moves one file into the permanent database locally or online.
         * @summary Moves one file into the permanent database.
         * @param {string} UUID The url of the file to move from the temp folders.
         * @param {string} Owner The ID of the User that owns the file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveFromTempToPermanent(UUID: string, Owner: string, options?: AxiosRequestConfig): Promise<AxiosResponse<MoveFileResponse>> {
            return FileApiFp(configuration).moveFromTempToPermanent(UUID, Owner, options).then((request) => request(axios, basePath));
        },
        /**
         * Moves multiple files into the permanent database. Each file can have different owners.
         * @summary Moves multiple files into the permanent database.
         * @param {MoveMultipleTempFilesToPermanentRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveMultipleTempFilesToPermanent(body?: MoveMultipleTempFilesToPermanentRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<MoveFilesResponse>> {
            return FileApiFp(configuration).moveMultipleTempFilesToPermanent(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload file into the temporary database locally or online.
         * @summary Upload file into the temporary database.
         * @param {string} [Type] 
         * @param {Blob} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileForm(Type?: string, File?: Blob, options?: AxiosRequestConfig): Promise<AxiosResponse<UploadFileResponse>> {
            return FileApiFp(configuration).uploadFileForm(Type, File, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload file into the temporary database locally or online.
         * @summary Upload file into the temporary database.
         * @param {string} [Type] 
         * @param {string} [Category] 
         * @param {Blob} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileWithCategoryForm(Type?: string, Category?: string, File?: Blob, options?: AxiosRequestConfig): Promise<AxiosResponse<UploadFileResponse>> {
            return FileApiFp(configuration).uploadFileWithCategoryForm(Type, Category, File, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * Deletes a file from the permanent or temporary database.
     * @summary Deletes a file from the permanent or temporary database.
     * @param {string} UUID The url of the file to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async deleteFile(UUID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<DeleteFileResponse>> {
        return FileApiFp(this.configuration).deleteFile(UUID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes old temporary files from the database. Goes through all temporary folders and removes the ones with a timestamp older than 3 days ago.
     * @summary Deletes old temporary files from the database.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async deleteOldTempFiles(options?: AxiosRequestConfig) : Promise<AxiosResponse<DeleteOldTempFilesResponse>> {
        return FileApiFp(this.configuration).deleteOldTempFiles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Downloads a file from the database, works on both temporary and permanent files. Works with all types of files.
     * @summary Downloads a file from the database, works on both temporary and permanent files.
     * @param {string} UUID The url of the file to get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async downloadFile(UUID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<DownloadFileResponse>> {
        return FileApiFp(this.configuration).downloadFile(UUID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a file from the database to view, works on both temporary and permanent files. Designed for Images and PDFs.
     * @summary Gets a file from the database to view, works on both temporary and permanent files.
     * @param {string} UUID The url of the file to get
     * @param {string} token The access token of the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async getFile(UUID: string, token: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetImageFileResponse>> {
        return FileApiFp(this.configuration).getFile(UUID, token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a category of a file from the database, works on both temporary and permanent files. Designed for Images and PDFs.
     * @summary Gets a category of a file from the database, works on both temporary and permanent files.
     * @param {string} UUID The url of the file to get
     * @param {string} token The access token of the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async getFileCategory(UUID: string, token: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetFileCategoryResponse>> {
        return FileApiFp(this.configuration).getFileCategory(UUID, token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Moves one file into the permanent database locally or online.
     * @summary Moves one file into the permanent database.
     * @param {string} UUID The url of the file to move from the temp folders.
     * @param {string} Owner The ID of the User that owns the file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async moveFromTempToPermanent(UUID: string, Owner: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<MoveFileResponse>> {
        return FileApiFp(this.configuration).moveFromTempToPermanent(UUID, Owner, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Moves multiple files into the permanent database. Each file can have different owners.
     * @summary Moves multiple files into the permanent database.
     * @param {MoveMultipleTempFilesToPermanentRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async moveMultipleTempFilesToPermanent(body?: MoveMultipleTempFilesToPermanentRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<MoveFilesResponse>> {
        return FileApiFp(this.configuration).moveMultipleTempFilesToPermanent(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload file into the temporary database locally or online.
     * @summary Upload file into the temporary database.
     * @param {string} [Type] 
     * @param {Blob} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async uploadFileForm(Type?: string, File?: Blob, options?: AxiosRequestConfig) : Promise<AxiosResponse<UploadFileResponse>> {
        return FileApiFp(this.configuration).uploadFileForm(Type, File, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload file into the temporary database locally or online.
     * @summary Upload file into the temporary database.
     * @param {string} [Type] 
     * @param {string} [Category] 
     * @param {Blob} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public async uploadFileWithCategoryForm(Type?: string, Category?: string, File?: Blob, options?: AxiosRequestConfig) : Promise<AxiosResponse<UploadFileResponse>> {
        return FileApiFp(this.configuration).uploadFileWithCategoryForm(Type, Category, File, options).then((request) => request(this.axios, this.basePath));
    }
}
